import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {DocumentRequest} from "../_models/documentRequest";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class DocumentRequestService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getDocumentRequestGroups() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/documentRequestGroup');
  }

  @Load()
  saveDocumentRequestGroup(documentRequestGroup: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/documentRequestGroup', documentRequestGroup);
  }

  @Load()
  deleteDocumentRequestGroup(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/documentRequestGroup/' + id + '');
  }

  getDocumentRequests(documentRequestGroupId) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/documentRequest/' + documentRequestGroupId);
  }

  @Load()
  saveDocumentRequest(documentRequest: DocumentRequest) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/documentRequest', documentRequest);
  }

  @Load()
  deleteDocumentRequest(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/documentRequest/' + id + '');
  }

  @Load()
  generateReport(id): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/documentRequest/' + id + '/generateReport', {
        responseType: 'arraybuffer',
        headers: {}
      });
  }

  @Load()
  import(entity: File, setId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + `/api/documentRequest/import/${setId}`, formData);
  }

  @Load()
  setIsAccepted(id, value) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/documentRequest/' + id + '/accepted/' + value);
  }

}
